import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./card.module.css";
export var Card = function(param) {
    var isHoverable = param.isHoverable, _element = param.element, element = _element === void 0 ? "div" : _element, children = param.children;
    var HtmlElement = element;
    return /*#__PURE__*/ _jsx(HtmlElement, {
        className: cx(styles.card, _define_property({}, styles.hoverable, isHoverable)),
        children: children
    });
};
